
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import Factors from '@/store/enums/IVEOtherFactorsEnums';

  export default defineComponent({
    name: 'sea-front-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('seaFrontLenghsFactorOptions'), [
          translate('ive'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_IVE_FACTOR_OPTIONS_STORE);
      });

      await store.dispatch(
        Actions.GET_IVE_FACTOR_OPTIONS,
        Factors.SEA_FRONT_LENGTHS
      );
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('seaFrontNameEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('seaFrontNameAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('multiplicationFactors'),
          key: 'multiplicationFactors',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const editSeaFront = (id) => {
        router.push({ name: 'sea-front-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_IVE_FACTOR_OPTION_CURRENT_PAGE,
          val
        );
        await store.dispatch(
          Actions.GET_IVE_FACTOR_OPTIONS,
          Factors.SEA_FRONT_LENGTHS
        );
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.factorOptionsList),
        tableHeader,
        translate,
        totalItems: computed(() => store.getters.factorOptionsListCount),
        pageChanged,
        goTo,
        editSeaFront,
        loading,
        can,
      };
    },
  });
